// extracted by mini-css-extract-plugin
export default {"SmartLayout":"smart-module_SmartLayout_kqN0i","SmartLayoutWrapper":"smart-module_SmartLayoutWrapper_W137i"};